
import { useSelector  } from 'react-redux';

import { getDataModelDefinition } from '../reducers';
import { getDataModelItem } from '../reducers/dataModelDefinition';

export default function useDataModelItem(mapLayer) {
    const dataModelDefinition = useSelector(state => getDataModelDefinition(state.data));
    let dataModelItem = (dataModelDefinition && mapLayer)
        ? getDataModelItem(dataModelDefinition, mapLayer.attachedDataModel)
        : null;
    return dataModelItem
}
